// extracted by mini-css-extract-plugin
export default {"controls":"Pagination_controls__RRrq0","total":"Pagination_total__ZFQyt"};